<template>
  <LineChart
    :chart-data="chartData"
    :options="options"
    :styles="styles"
  />
</template>

<script>
import { LineChart } from '@/components/charts/'
import * as moment from 'moment'

export default {
  components: {
    LineChart
  },
  props: {
    from: {
      type: String,
      default: () => null
    },
    fromRecords: {
      type: Array,
      default: () => []
    },
    to: {
      type: String,
      default: () => null
    },
    toRecords: {
      type: Array,
      default: () => []
    },
    replacedAt: {
      type: Number,
      default: () => null
    },
    sensorInstalledAt: {
      type: Number,
      default: () => null
    }
  },
  data () {
    return {
      tickInfo: '',
      maxValue: 0,
      styles: {
        height: '100%',
        width: '100%',
        position: 'relative'
      },
      options: {
        responsive: true,
        animation: false,
        maintainAspectRatio: false,
        tooltips: {
          enabled: false
        },
        legend: {
          labels: {
            filter: ({ text }) => {
              if (text === 'hidden' ||
                (!this.from && text.startsWith('交換前')) ||
                (!this.to && text.startsWith('交換後'))
              ) return false
              return true
            } }
        },
        scales: {
          xAxes: [
            {
              type: 'time',
              ticks: {
                maxTicksLimit: 10
              },
              time: {
                displayFormats: {
                  second: 'H:mm',
                  minute: 'H:mm',
                  hour: 'M/D H時',
                  day: 'M/D'
                }
              }
            }
          ],
          yAxes: [
            {
              gridLines: false,
              ticks: {
                beginAtZero: true,
                callback: (value) => {
                  if (value > this.maxValue) this.maxValue = value
                  return value
                }
              }
            }
          ]
        }
      }
    }
  },
  computed: {
    chartData () {
      return {
        datasets: [
          {
            label: `${this.to ? '交換前：' : ''}${this.from} ${this.timestampToDateText(this.sensorInstalledAt)}`,
            lineTension: 0,
            borderColor: 'rgb(255, 109, 65)',
            backgroundColor: 'rgba(255, 109, 65, 0.2)',
            data: this.map(this.fromRecords)
          },
          {
            label: `${this.from ? '交換後：' : ''}${this.to}`,
            lineTension: 0,
            borderColor: 'rgb(82, 146, 250)',
            backgroundColor: 'rgba(82, 146, 250, 0.2)',
            data: this.map(this.toRecords)
          },
          {
            type: 'bar',
            label: 'hidden',
            barThickness: 1,
            borderWidth: 0,
            backgroundColor: '#004914',
            data: [{ x: moment.unix(this.replacedAt), y: this.maxValue }]
          }
        ]
      }
    }
  },
  methods: {
    map (list) {
      if (list == null) {
        return list
      }
      return list.map(r => ({
        x: moment.unix(r.timestamp),
        y: r.value
      }))
    },
    timestampToDateText (timestamp) {
      if (!timestamp) return ''

      const [date, time] = new Date(timestamp * 1000)
        .toLocaleString('ja-JP')
        .split(' ')
      return `(${date} ${time.slice(0, time.length - ':SS'.length)}に設置)`
    }
  }
}
</script>
